import styled from 'styled-components';

import { SKELETON } from '../../theme/tokens';

// --- Stacked variant (inline values) ----------------------------------------
// The placeholder and the real value share ONE grid cell, so the box sizes to
// the larger of the two and they overlap perfectly — the value never shifts on
// reveal, and the two can cross-fade in place.
export const Stack = styled.span`
  display: inline-grid;
  /* Sit on the text baseline like the bare value it replaces. */
  vertical-align: middle;
  align-items: center;

  & > * {
    grid-area: 1 / 1;
    min-width: 0;
  }
`;

export const Layer = styled.span<{ $visible: boolean }>`
  opacity: ${(p) => (p.$visible ? 1 : 0)};
  transition: opacity ${SKELETON.CROSSFADE_MS}ms ease;
  /* The faded-out layer must not swallow clicks meant for the live one. */
  pointer-events: ${(p) => (p.$visible ? 'auto' : 'none')};
  min-width: 0;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

// --- Overlay variant (pre-sized bars / gauge rings) --------------------------
// Fills the box its parent already reserves (a track, a ring). The real content
// renders in normal flow (keeping its own entrance animation + positioning); the
// placeholder rides on top as an absolute layer and fades out over it.
export const OverlayRoot = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const OverlayLayer = styled.div<{ $visible: boolean }>`
  position: absolute;
  inset: 0;
  opacity: ${(p) => (p.$visible ? 1 : 0)};
  transition: opacity ${SKELETON.CROSSFADE_MS}ms ease;
  pointer-events: none;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
